/**
 * Bind async link loaders: show spinner on ajax:beforeSend, remove on ajax:complete.
 */
export function initAsyncLinkLoaders(container) {
  const ASYNC_LINK_SPINNER_CLASS = 'ajax-loader-small';
  if (!container) return;
  const asyncLinks = container.querySelectorAll('a[data-remote="true"], .js-showing-view-request-documents-btn');
  asyncLinks.forEach((link) => {
    if (link.dataset.asyncLoaderBound === 'true') return;
    link.dataset.asyncLoaderBound = 'true';
    link.addEventListener('ajax:beforeSend', (e) => {
      if (e.target !== link) return;
      link.classList.add('disabled');
      if (!link.querySelector(`.${ASYNC_LINK_SPINNER_CLASS}`)) {
        link.insertAdjacentHTML('beforeend', `<div class="${ASYNC_LINK_SPINNER_CLASS}"></div>`);
      }
    });
    link.addEventListener('ajax:complete', (e) => {
      if (e.target !== link) return;
      link.classList.remove('disabled');
      link.querySelector(`.${ASYNC_LINK_SPINNER_CLASS}`)?.remove();
    });
  });
}
